module.exports = __webpack_public_path__ + "static/img/wx-pay-tip.a4a59064.png";